var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Portlet',{staticClass:"mediaReviewReport",attrs:{"title":'Report',"icon":"receipt"}},[_c('MediaReviewReportList',{ref:"meidaReviewReportList"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }